export const FONT_TYPES = {
  CUSTOM: 'custom'
};
